import { VideoSourceInterface } from '../type/videoSourceType';

/**
 * feed_format 계열 필드를 payload에 합친다.
 *
 * 백엔드 계보에 따라 필드가 없을 수 있고(main 계보에는 default_season/default_language가
 * 아직 없다) 그 경우 폼에도 렌더되지 않아 값이 undefined다. undefined는 payload에서
 * 제외해 서버 기본값을 그대로 두고, 고정 시즌 해제(null)는 그대로 전달한다.
 */
export const buildFeedFormatPayload = (
  values: Record<string, unknown>
): Partial<VideoSourceInterface> => {
  const payload: Partial<VideoSourceInterface> = {};

  if (values.feed_format !== undefined) {
    payload.feed_format = values.feed_format as string;
  }
  if (values.default_season !== undefined) {
    payload.default_season = (values.default_season as number) || null;
  }
  if (values.default_language !== undefined) {
    payload.default_language = values.default_language as string;
  }
  if (values.import_limit !== undefined && values.import_limit !== null) {
    payload.import_limit = Number(values.import_limit);
  }
  if (values.batch_job_queue !== undefined) {
    payload.batch_job_queue = values.batch_job_queue as string;
  }

  return payload;
};
